import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const ArrowBottomLeftIcon = ({ className = '', width = 13,  height = 13 , color = 'currentColor' }) => {
    return (
        <svg
            className={`icon-13-13 ${className ? className : ''}`}
            fill='none'
            height={height}
            viewBox='0 0 13 13'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                clipRule='evenodd'
                d='M2.00019 11.1221L9.38068 11.1221L9.38068 10.1303L3.7831 10.1303L11.2097 2.7037L10.5062 2.00021L2.99762 9.50882L2.99762 3.78357L2.00019 3.78357L2.00019 11.1221Z'
                fill={color}
                fillRule='evenodd'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default ArrowBottomLeftIcon;
